import { lighten, makeStyles } from '@material-ui/core/styles';
import React, { VFC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Typography } from '../Typography';
import { EventListIcon, ListIcon } from './icons';

const useStyles = makeStyles(theme => ({
  card: {
    borderRadius: '15px',
    boxShadow: 'rgba(0, 0, 0, 0.25) 0px 2.30916px 4.61832px',
    padding: theme.spacing(1.5),
    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    },
  },
  title: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  icon: {
    color: theme.palette.common.gray800,
  },
  capsuleWrapper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  capsule: {
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    background: lighten(theme.palette.common.gray100, 0.5),
    padding: `8px 16px`,
    borderRadius: '12px',
    gap: theme.spacing(1),
  },
  listIcon: {
    color: theme.palette.common.gray800,
    width: '18px',
    height: '18px',
  },
}));

export interface RequirementsProps {
  requirements: string[];
}

export const Requirements: VFC<RequirementsProps> = ({ requirements }) => {
  const intl = useIntl();
  const styles = useStyles();
  return (
    <div className={styles.card}>
      <div className={styles.title}>
        <EventListIcon
          aria-label={intl.formatMessage({
            defaultMessage: 'Highlights icon',
            description: 'Indicates job highlights',
          })}
          className={styles.icon}
        />
        <Typography variant="headingSM">
          <FormattedMessage
            defaultMessage="Highlights"
            description="Highlights section header"
          />
        </Typography>
      </div>
      <div className={styles.capsuleWrapper}>
        {requirements.map(requirement => (
          <li key={requirement} className={styles.capsule}>
            <ListIcon
              aria-label={intl.formatMessage({
                defaultMessage: 'List icon',
                description: 'Indicates each list item',
              })}
              className={styles.listIcon}
            />
            <Typography variant="body">{requirement}</Typography>
          </li>
        ))}
      </div>
    </div>
  );
};
